import type { Tax } from "@jti/magento";
import type { MagentoCustomerCartPrices, MagentoPrice } from "@jti/magento-types";

import type { FreeTrialPrice } from "../types/FreeTrialCart.types";

export const mapFreeTrialPriceFromCartPrices = (cart: Partial<MagentoCustomerCartPrices["cart"]>): FreeTrialPrice => {
  const item = cart.items?.[0] || null;
  const totalAfterTrial = cart.totalAfterTrial?.total?.value ?? 0;
  const totalAfterTrialInclTax = cart.totalAfterTrial?.totalInclTax?.value ?? 0;
  const grandTotal = cart.prices?.grandTotal;
  const subtotal = cart.totalIncludingTrial?.totalInclTax?.value ?? 0;
  const deposit = cart.prices?.subtotalIncludingTax?.value ?? 0;
  const discount = item?.product?.priceRange?.minimumPrice?.discount?.amountOff ?? 0;
  const shipping = cart.shippingAddresses?.[0]?.selectedShippingMethod?.amount?.value ?? 0;
  const appliedTaxes = cart.prices?.appliedTaxes || [];
  const totalNowTax: Tax[] = appliedTaxes.map((tax) => ({
    amount: tax.amount,
    label: tax.label,
  }));
  const total = grandTotal?.value ?? 0;

  const afterTrialTax: MagentoPrice | null = cart.totalAfterTrial?.tax || null;
  const totalAfterTrialTax: Tax[] = [];

  if (afterTrialTax && appliedTaxes.length) {
    totalAfterTrialTax.push({
      amount: afterTrialTax,
      label: "totalAfterTrialTax",
    });
  }

  return {
    currency: grandTotal?.currency ?? "",
    subtotal,
    deposit,
    shipping,
    total,
    discount,
    totalNowTax,
    totalAfterTrial,
    totalAfterTrialTax,
    totalAfterTrialInclTax,
  };
};
